// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"c02185e5","787":"70f1a50b"}[chunkId] + ".chunk.js";
};